<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.22 15.57">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_1082" data-name="Group 1082">
          <g id="Group_1081" data-name="Group 1081">
            <path
              id="Path_412"
              data-name="Path 412"
              class="cls-1"
              d="M15.22,5.06c0,.21,0,.42,0,.63a.75.75,0,0,1-.73.76h-.41c-.13,0-.16,0-.16-.16V3.82c0-.11.05-.16.16-.15a3.77,3.77,0,0,1,.58,0,.71.71,0,0,1,.56.71C15.23,4.63,15.22,4.84,15.22,5.06Z"
            />
            <path
              id="Path_413"
              data-name="Path 413"
              class="cls-1"
              d="M15.22,8.15c0,.21,0,.42,0,.64a.74.74,0,0,1-.73.75h-.41c-.13,0-.16,0-.16-.16V6.92c0-.12.05-.17.16-.16a3.77,3.77,0,0,1,.58,0,.71.71,0,0,1,.56.71C15.23,7.72,15.22,7.94,15.22,8.15Z"
            />
            <path
              id="Path_414"
              data-name="Path 414"
              class="cls-1"
              d="M15.22,11.16c0,.21,0,.43,0,.64a.73.73,0,0,1-.72.75h-.42c-.13,0-.16,0-.16-.16V9.93c0-.12.05-.16.16-.16a5.65,5.65,0,0,1,.58,0,.71.71,0,0,1,.56.71C15.23,10.74,15.22,11,15.22,11.16Z"
            />
            <path
              id="Path_415"
              data-name="Path 415"
              class="cls-1"
              d="M15.22,14.18c0,.21,0,.43,0,.64a.73.73,0,0,1-.72.75h-.42c-.13,0-.16,0-.16-.16V13c0-.12.05-.17.16-.16a5.65,5.65,0,0,1,.58,0,.71.71,0,0,1,.56.71C15.23,13.75,15.22,14,15.22,14.18Z"
            />
          </g>
          <path
            id="Path_416"
            data-name="Path 416"
            class="cls-1"
            d="M2.35,1.1h10.7V0H2.43A2.43,2.43,0,0,0,0,2.43V12.5a3.07,3.07,0,0,0,3.07,3.07h9.58a.39.39,0,0,0,.4-.4h0V4.38a.69.69,0,0,0-.69-.69h-10A1.3,1.3,0,0,1,1,2.42,1.33,1.33,0,0,1,2.35,1.1Zm1,6H11V8.8H3.38Zm0,3.39H11v1.69H3.38Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
